<template>
  <div class="home-container">
    <!-- 导航栏 -->
    <van-nav-bar class="nav-bar newnavbar" :title="$store.getters.getBaseInfo.site_name">
      <template #left>
        <van-image src="img/mine/mall.png" width="35" height="35" @click="toMall()">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
      </template>
      <template #right>
        <van-image src="img/mine/kf.png" width="35" height="35" @click="toService()">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
      </template>
      <template #title>
        <van-image class="menu-item-icon" style="margin: 10px 0 0 0;" height="40"
          :src="$store.getters.getBaseInfo.site_icon"> </van-image>
      </template>
    </van-nav-bar>
    <div class="linear-bg"></div>
    <div class="home-scroll">
      <!-- 轮播图 -->
      <div class="banner">
        <van-swipe :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(v, key) in banners" :key="key">
            <van-image :src="v" :height="200" width="100%" fit="cover">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error><van-image src="img/error.png" /></template>
            </van-image>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 滚动通知 -->
      <div class="notice-bar" style="padding: 8px; background: rgb(243, 243, 245);">
        <van-notice-bar class="notice-swipe" :left-icon="require('@/assets/laba.png')" background="#ffffff"
          color="#000000" :text="notice" />
        <div class="linear-gradient"></div>
      </div>
      <!-- 选妃横排 -->
      <div style="padding: 10px;">
        <div style="margin-bottom: 10px; font-size: 16px;">{{ $t('highEndZone') }}
          <i style="background: #000000; padding: 4px; color: #fff; font-size: 12px; border-radius: 8px 0 8px 0;">{{
            $t('EnjoyTheUltimateLuxuryExperience') }}</i>
        </div>
        <div style="display: flex; width: 100%; overflow-y: auto; flex-wrap: nowrap;">
          <div class="gdgride" style="margin-right: 5px;" v-for="(v, i) in datalist_horizontal" :key="i">
            <div v-for="(v2, i2) in v" :key="i2" @click="profile(v2)">
              <van-image :src="v2.goods_pic" :height="100" :width="100" :radius="8" fit="cover">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
                <template v-slot:error><van-image src="img/error.png" /></template>
              </van-image>
              <span><i>{{ $t('airborne') }}</i></span>
              <div
                style="position: absolute; bottom: 10px; text-align: center; color: #fff; width: 100%; font-size: 12px;">
                {{ v2.goods_name || '' }}</div>
            </div>
          </div>
          <div
            style="width: 23px; padding: 20px 5px 10px; height: 145px; margin-top: 30px; background: #f9f9f9; color: #999; font-size: 12px;"
            @click="toMore">{{ $t('viewMoreData') }}</div>
        </div>
      </div>
      <!-- 选妃竖排 -->
      <div style="padding: 10px;">
        <div style="font-size: 16px;">{{ $t('aboutCannonRecommend') }}</div>
        <div>
          <horizontalItem v-for="(v, i) in datalist_vertikale" :key="i" :rowData="v"></horizontalItem>
        </div>
      </div>
      <!-- 在线匹配人数名单 -->
      <div
        style="background: linear-gradient(90deg, #323233, #000000); width: 96%; margin: 0 auto 30px; border-radius: 8px; overflow: hidden; padding-bottom: 10px;">
        <div style="color: #e9b387; text-align: center; padding: 10px 0;">{{ $t('current') }} {{ getRandomInt(5500,
          6000) }}
          {{
            $t('peopleNowMatch')
          }}</div>
        <vue-seamless-scroll :data="onlineUsers" :class-option="{
          singleHeight: 18
        }" class="OnlineMatching">
          <ul class="item">
            <li v-for="(item, index) in onlineUsers" :key="index">{{ item.title }}</li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <van-popup v-model="showPop" :style="{ width: '90%', height: '65%' }" closeable round>
      <div class="indexPop" v-html="popContent"></div>
    </van-popup>
  </div>
</template>

<script>
import horizontalItem from '@/common/horizontalItem.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'
import config from "../../http/config";
export default {
  components: {
    horizontalItem,
    vueSeamlessScroll
  },
  data() {
    return {
      config,
      datalist_horizontal: [[]],
      datalist_vertikale: [],
      onlineUsers: [],
      notice: "",
      banners: [],
      popContent: "",
      showPop: false,
    };
  },
  created() {
    this.getBanner();
    this.getNotice();
    this.getIndexPop();
    this.getxuanfeilist();
    this.getonlineUsers();
  },
  methods: {
    // 首页滚动内容
    getNotice() {
      this.$httpNew({
        method: 'get',
        data: {
          id: this.NotifyIds[this.$i18n.locale],
        },
        url: 'get_notice'
      }).then(res => {
        if (res.code == 0) {
          this.notice = res.content.replace(/<[^>]*>/g, '');
        } else {
          this.notice = "";
        }
      })
    },
    // 首页弹框内容
    getIndexPop() {
      this.$httpNew({
        method: 'get',
        data: {
          id: this.IndexPopId[this.$i18n.locale],
        },
        url: 'get_notice'
      }).then(res => {
        if (res.code == 0) {
          this.popContent = res.content;
          this.showPop = true;
        } else {
          this.popContent = "";
          this.showPop = false;
        }
      })
    },
    // 轮播图
    getBanner() {
      this.$httpNew({
        method: 'post',
        data: {},
        url: 'get_banners'
      }).then(res => {
        if (res.code == 0) {
          this.banners = res.images || [];
        } else {
          this.banners = [];
        }
      })
    },
    // 选妃列表
    getxuanfeilist() {
      this.$httpNew({
        method: 'get',
        url: 'get_goods_list',
        data: {
          type: this.GoodsInfo[this.$i18n.locale],
        }
      }).then(res => {
        if (res.code == 0) {
          this.datalist_horizontal = this.group(res.data, 2);
          this.datalist_vertikale = res.data;
        } else {
          this.datalist_horizontal = [[]];
          this.datalist_vertikale = [];
        }
      });
    },
    // 在线匹配人数
    getonlineUsers() {
      const germanMaleNames = [
        "Alexander", "Ben", "Christian", "David", "Erik",
        "Fabian", "Georg", "Hans", "Jonas", "Karl",
        "Leon", "Lukas", "Max", "Moritz", "Niklas",
        "Oliver", "Paul", "Philipp", "Ralf", "Sebastian",
        "Stefan", "Tobias", "Uwe", "Viktor", "Walter",
        "Wolfgang", "Andre", "Björn", "Claus", "Dirk",
        "Elias", "Friedrich", "Günther", "Heinrich", "Jan",
        "Jürgen", "Klaus", "Manfred", "Norbert", "Otto",
        "Peter", "Rainer", "Simon", "Thomas", "Ulrich",
        "Werner", "Yannik", "Zacharias", "Dominik", "Florian"
      ];
      const englishMaleNames = [
        "Aaron", "Adam", "Alexander", "Andrew", "Anthony",
        "Benjamin", "Blake", "Bradley", "Brandon", "Brian",
        "Caleb", "Cameron", "Charles", "Christopher", "Colin",
        "Daniel", "David", "Dominic", "Dylan", "Edward",
        "Ethan", "Eric", "Evan", "Gabriel", "George",
        "Henry", "Hunter", "Ian", "Isaac", "Jack",
        "Jacob", "James", "Jason", "John", "Jonathan",
        "Joseph", "Joshua", "Justin", "Kevin", "Liam",
        "Lucas", "Matthew", "Michael", "Nathan", "Nicholas",
        "Noah", "Oliver", "Patrick", "Ryan", "Samuel"
      ];
      const spanishBoyNames = [
        "Alejandro", "Santiago", "Mateo", "Diego", "Lucas",
        "Adrián", "Carlos", "Fernando", "Gabriel", "Javier",
        "Pablo", "Manuel", "Hugo", "Martín", "Andrés",
        "Antonio", "Ricardo", "Luis", "Emilio", "Raúl",
        "Felipe", "Jorge", "Víctor", "Alberto", "Roberto",
        "César", "Ramón", "Iván", "David", "Oscar",
        "Rafael", "Francisco", "Salvador", "Esteban", "Héctor",
        "Gonzalo", "Eduardo", "Nicolás", "Ángel", "Tomás",
        "Jesús", "Samuel", "Mario", "Ignacio", "Enrique",
        "Benjamín", "Bruno", "Emmanuel", "Simón", "Cristian"
      ];
      const frenchMaleNames = [
        "Adrien", "Benoît", "Christophe", "Damien", "Émile",
        "François", "Gaspard", "Henri", "Isidore", "Jérôme",
        "Kévin", "Loïc", "Matthieu", "Nicolas", "Olivier",
        "Pascal", "Quentin", "Rémy", "Stéphane", "Théo",
        "Ulysse", "Victor", "William", "Xavier", "Yannick",
        "Zacharie", "Antoine", "Bernard", "Charles", "Denis",
        "Étienne", "Fabrice", "Georges", "Hugo", "Ivan",
        "Jean", "Karim", "Luc", "Maxime", "Noël",
        "Paul", "René", "Sébastien", "Tristan", "Vincent",
        "Walter", "Yves", "Alexandre", "Claude", "Didier"
      ];
      const thaiBoyNames = [
        "อาทิตย์", "กิตติ", "ชัยวัฒน์", "ปกรณ์", "ณัฐพล",
        "อนุชา", "ศักดิ์สิทธิ์", "วีระ", "ธนากร", "สุริยา",
        "วิทยา", "พงษ์ศักดิ์", "สมชาย", "ประเสริฐ", "นรินทร์",
        "ปรีชา", "จักรพงษ์", "วรพล", "เอกชัย", "ภัทร",
        "อนันต์", "ภูมิพัฒน์", "จิรพงษ์", "สิทธิชัย", "กฤษณ์",
        "ทวี", "บวร", "คณิต", "จตุพล", "ชยพล",
        "วิเชียร", "รณชัย", "ณรงค์", "ศรัณย์", "ฐากร",
        "ทรงพล", "นพพร", "ธวัชชัย", "ปรีดา", "วรพงษ์",
        "ก้องภพ", "ภูมิใจ", "ธีรภัทร", "ปรเมศวร์", "พิชัย",
        "เดชากร", "สถาพร", "ธนภพ", "ภาณุพงศ์", "นเรศ"
      ];

      if (this.$i18n.locale == 'en') {
        germanMaleNames.map(v => {
          this.onlineUsers.push({ title: v + `  ${this.$t('accountMembership')}` });
        })
      } else if (this.$i18n.locale == 'de') {
        englishMaleNames.map(v => {
          this.onlineUsers.push({ title: v + `  ${this.$t('accountMembership')}` });
        })
      } else if (this.$i18n.locale == 'es') {
        spanishBoyNames.map(v => {
          this.onlineUsers.push({ title: v + `  ${this.$t('accountMembership')}` });
        })
      } else if (this.$i18n.locale == 'fr') {
        frenchMaleNames.map(v => {
          this.onlineUsers.push({ title: v + `  ${this.$t('accountMembership')}` });
        })
      } else if (this.$i18n.locale == 'th') {
        thaiBoyNames.map(v => {
          this.onlineUsers.push({ title: v + `  ${this.$t('accountMembership')}` });
        })
      }
    },
    profile(v) {
      this.$router.push({
        path: '/profile?id=' + v.id
      });
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },
    toService() {
      this.$router.push({ path: '/customerservice' });
    },
    toMore() {
      this.$router.push({
        path: 'Choose'
      });
    },
    getRandomInt(min, max) {
      // 确保 min 和 max 是整数
      min = Math.ceil(min);
      max = Math.floor(max);
      // 生成 min 到 max（包括 min 和 max）的随机整数
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    toMall() {
      this.$router.push({ path: '/Mall' });
    },
  },
}

</script>

<style lang='less' scoped>
@notice-bar-size: 30px;
@movie-list-item-bottom-size: 25px;

.gdgride {
  padding-right: 20px;

  >div {
    position: relative;
    overflow: hidden;
    border-radius: 8px;

    >span {
      position: absolute;
      z-index: 9;
      background-color: #000000;
      color: #fff;
      transform: rotate(45deg);
      width: 150px;
      height: 150px;
      font-size: 24px;
      top: -80px;
      right: -80px;

      >i {
        position: absolute;
        bottom: 5px;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
      }
    }
  }
}

.linear-bg {
  height: 170px;
  // background: linear-gradient(270deg, #e6c3a1, #7e5678);
  // background: linear-gradient(30deg, #7d76ef, #d63f8c);
}

.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
}

.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
}

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  min-width: 40px;
}

::v-deep .van-notice-bar__left-icon {
  font-size: 32px;
}

.notice-swipe {
  // width: calc(100% - 50px);
  height: 85px;
  font-size: @notice-bar-size;
  border-radius: 50px;
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.banner {
  width: 100%;
  margin-top: -23%;
}

.banner_swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

// .banner_img {
//   border-radius: 10px;
//   width: 100%;
//   height: 100%;
// }

.hot-game {
  width: 100%;
  height: 100%;
}

.hot-title-div {
  width: calc(100% - 50px);
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hot-title-div>div:first-child {
  width: 50%;
}

.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hot-title-div>div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}

.hot-title-div>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 10px;
  font-weight: 700;
  color: #000;
}

.hot-title-div>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 28px;
  font-weight: 700;
  color: #000;
}

.hot-title-div>div:nth-child(2) span {
  font-size: 25px;
  color: #979799;
}

// .hot-title-div>div:first-child span:before {
//   content: "";
//   display: block;
//   width: 5px;
//   height: 30px;
//   background-color: #7e5678;
//   border-radius: 1px;
//   margin-right: 5px;
// }

.hot-game .hot-items-div {
  margin-top: -3px;
}

.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 28px;
  color: #000;
}

.hot-recommend {
  width: 100%;
  flex: 1;
  background-color: #f2f2f5;
}

.movie_swiper {
  .swiper-slide {
    width: 80%;
  }
}

.movie_list_0 {
  width: calc(100% - 50px);
  margin: 0 auto;
}

.movie_cover {
  border-radius: 10px;
  width: 550px;
  height: 330px
}

.movie_list_0 .movie-list-item-bottom {
  position: relative;
  width: 550px;
  bottom: 43px;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_0 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
  font-size: 28px;
  color: #fff;
}

.movie_list_0 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
}

.movie_list_0 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}

.movie_list_0 span {
  font-size: 30px;
}

.movie_list_1 {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.movie_list_1 .movie-list-item .cover_img {
  border-radius: 10px;
  width: 335px;
  height: 290px;
}

.home-scroll {
  padding-bottom: 110px;
}

.movie_list_1 .movie-list-item {
  margin-bottom: -10px;
}

.movie_list_1 .movie-list-item-bottom {
  position: relative;
  width: 335px;
  bottom: 42px;

}

.movie_list_1 .movie-list-item:nth-child(odd) {
  margin-right: 25px;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_1 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
  height: 35px;
}

.movie_list_1 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 5px;
}

.movie_list_1 .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.movie_list_1 .movie-list-item .movie-time-div span:last-child {
  overflow: hidden;
  white-space: nowrap;
  width: 0px;
  padding-right: 110px;
  font-size: 22px;
}

.movie_list_0 .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
  padding-left: 10px;
  font-size: 25px;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

.hot-items-div .game_item_img {
  width: 120px;
  height: 150px;
}

::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

.newnavbar {
  // background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;
  background: #000000;

}

.OnlineMatching {
  height: 210px;
  overflow: hidden;


  li {
    text-align: center;
    color: #fff;
    font-size: 28px;
    margin-top: 10px;
  }
}

.indexPop {
  padding: 0 20px 10px;
  height: calc(100% - 80px);
  overflow: auto;
  margin: 80px 0 0;
  box-sizing: border-box;
}

::v-deep .van-popup__close-icon {
  color: #000;
  font-size: 40px;
}
</style>
